import { createContext, useContext } from "react";
import type { z } from "zod";

import { EMPTY } from "../str";

import type { Config } from "./config";

const ConfigContext = createContext<Config<z.KeySchema, z.ZodType<string, z.ZodTypeDef>>>({
  app: {
    flatRoleByRoleId: {},
    adminPanelRoute: EMPTY,
    host: EMPTY,
  },
  backendApp: {
    protocol: "http",
    address: "localhost",
    port: 8083,
    apiBaseUrl: "api",
  },
  nodeEnv: "dev",
  google: {
    googleConversionTagId: EMPTY,
    googleConversionLabels: {
      ORDER_CREATION: EMPTY,
    },
  },
});

function useConfig() {
  return useContext(ConfigContext);
}

export { ConfigContext, useConfig };
